<template>
    <div>
        <div class="fixed-top bg-white headerbar underline">
            <div class="py-2 screenWidth">
                <div class="row">
                    <!-- 漢堡 -->
                    <div class="float-left d-inline-block d-md-none col-2">
                        <MenuIcon class="cursorPoint"
                                size="1.7x"
                                :data-ga-element="`${gaData}搜尋Icon`"
                                @click="openMenuBlock()" />
                    </div>
                    <!-- logo -->
                    <div class="logo d-inline-block px-0 px-sm-3 col-8 text-center text-md-left">
                        <a href="https://www.fubon.com/life/" target="_blank">
                            <img src="@/assets/images/header/logo.svg"
                                alt="富邦人壽，24小時為您服務 網友真心推薦！"
                                class="logoImg" />
                        </a>
                        <span @click="goHome()"
                            class="cursorPoint"
                            :data-ga-element="`${gaData}富邦人壽LOGO`">
                            <h1 class="sublogo"
                                :data-ga-element="`${gaData}富邦人壽LOGO`">
                                健康及保險知識+
                            </h1>
                        </span>
                    </div>
                    <!-- 右邊區塊 -->
                    <div class="text-right d-inline-block col-2 col-md-4">
                        <SearchIcon class="cursorPoint"
                                    v-if="!isShowSearchBlock"
                                    size="1.7x"
                                    @click="showSearchBlock()"
                                    :data-ga-element="`${gaData}搜尋Icon`" />
                        <XIcon class="cursorPoint"
                            v-else
                            size="1.75x"
                            @click="showSearchBlock()"
                            :data-ga-element="`${gaData}搜尋關閉Icon`" />
                    </div>
                </div>
            </div>
        </div>
        <!-- 遮罩 -->
        <div v-if="isShowSearchBlock || isShowMenuBlock"
             class="cover"
             @click="closeAllBlock()" />
        <!-- 搜尋畫面 -->
        <transition :enter-active-class="
                isOver768 ? 'movedown-enter-active' : 'move-enter-active'
            "
                    :leave-active-class="
                isOver768 ? 'movedown-leave-active' : 'move-leave-active'
            ">
            <div v-if="isShowSearchBlock"
                 class="searchBlock">
                <div class="px-0 px-md-3 px-lg-5 pt-md-3 pb-md-5 row bg-white d-md-flex screenWidth ">
                    <div class="col-12 d-md-none underline pt-2 pb-1 px-2">
                        <XIcon class="cursorPoint"
                               size="2.25x"
                               stroke-width="1.5"
                               @click="showSearchBlock()" />
                    </div>
                    <!-- 搜尋本文 -->
                    <div class="d-block d-md-flex no-gutters searchBlock__content">
                        <div class="col-12 col-md-7 px-3 pl-md-0 pr-md-3">
                            <div class="mb-0 mb-md-2 mt-md-0">
                                <Theme :titleText="'關鍵字搜尋'"
                                       :font20="true"
                                       class="mb-3 mb-md-4 mt-1" />
                                <div>
                                    <input type="text"
                                           class="form-control search__input rounded-pill pt-2"
                                           placeholder="請輸入關鍵字"
                                           v-model.trim="inputText"
                                           @input="inputValid(inputText)" />
                                    <button type="button"
                                            class="btn btn-sec search__btn d-inline-block rounded-pill pt-2"
                                            :disabled="disabled"
                                            @click="goToSearchPage()">
                                        搜尋
                                    </button>
                                    <div class="errorMsg">{{errorMsg}}</div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <Theme :titleText="'熱門關鍵字'"
                                       :underline="false"
                                       :font20="true"
                                       class="mb-0 mt-1" />
                                <Loading v-if="loading"
                                         :height="'50px'" />
                                <badge v-for="badge in badgeList"
                                       :key="badge"
                                       :badge="badge"
                                       :contentPage="contentPage"
                                       @closeAllBlock="closeAllBlock" />
                            </div>
                        </div>
                        <div class="col-12 col-md-5  px-3 pr-md-0 pl-md-3">
                            <Theme :titleText="'熱搜內容'"
                                   :font20="true"
                                   class="mb-3 mt-1" />
                            <Loading v-if="loading"
                                     :height="'50px'" />
                            <div v-for="(item, index) in articleRes"
                                 @click="closeAllBlock"
                                 :key="index">
                                <ArticleList :article="item"
                                             :type="'s'"
                                             :noDate="true"
                                             class="mb-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <Menu :isShowMenuBlock="isShowMenuBlock"
              @closeMenuBlock="closeMenuBlock" />
    </div>
</template>
<script>
import { get } from '@/api';
import Menu from './Menu.vue';
import Theme from '@/components/Theme.vue';
import Badge from '@/components/Badge.vue';
import ArticleList from '@/components/ArticleList.vue';
import Loading from '@/components/Loading.vue';
import { SearchIcon, XIcon, MenuIcon } from 'vue-feather-icons';
import { debounce } from 'debounce';

export default {
    name: 'layoutHeader',
    components: { SearchIcon, XIcon, Menu, MenuIcon, Theme, ArticleList, Badge, Loading },
    data() {
        return {
            disabled: false,
            loading: false,
            contentPage: '天版',
            isShowSearchBlock: false,
            isShowMenuBlock: false,
            inputText: '',
            errorMsg: '',
            textError: false,
            badgeList: [
                '親子餐廳',
                '武松打虎',
                '醫療險',
                '保險知識',
            ],
            articleRes: [
                {
                    categories: ['保險'],
                    onDate: undefined,
                    content: '',
                    contentId: '',
                    contentPreview: {},
                    contentTitle: '主題內容',
                    contentType: '',
                    tags: ['tages', 'tages1', 'tages2'],
                },
            ],
            isOver768: false,
        };
    },
    computed: {
        gaData() {
            return (
                this.systemName +
                '|' +
                this.contentPage +
                '|'
            );
        },
    },
    created() {
        this.getArticleList = debounce(this.getData, 500);
        this.getArticleList();
    },
    watch: {
        immediate: true,
        isShowSearchBlock() {
            this.$store.dispatch('setLockVeiw', this.isShowSearchBlock);
        },
        isShowMenuBlock() {
            this.$store.dispatch('setLockVeiw', this.isShowMenuBlock);
        },
    },
    methods: {
        getData() {
            this.disabled = true;
            this.loading = true;
            const tags = 4;
            const article = 2;
            get(`/api/content/tagsAndRandomContents?contentTags=${tags}&randomNum=${article}`)
                .then((res) => {
                    if (res.status === 200) {
                        if (res.response) {
                            this.articleRes = res.response.randomContents;
                            this.badgeList = res.response.tags;
                        }
                    } else {
                        this.go404Page(res.status);
                    }
                })
                .catch((error) => {
                    this.go404Page(error.status);
                }).finally(() => {
                    this.disabled = false;
                    this.loading = false;
                });
        },
        showSearchBlock() {
            this.isShowSearchBlock = !this.isShowSearchBlock;
            this.isOver768 = window.innerWidth >= 768;
        },
        openMenuBlock() {
            this.isShowMenuBlock = true;
        },
        closeMenuBlock() {
            this.isShowMenuBlock = false;
        },
        closeSearchBlock() {
            this.isShowSearchBlock = false;
        },
        closeAllBlock() {
            this.closeSearchBlock();
            this.closeMenuBlock();
        },
        goHome() {
            this.closeAllBlock();
            this.$router.push('/HomePage').catch(() => { });
        },
        inputValid(e) {
            // const value = this.inputText.trim();
            // const reg = /[\u4e00-\u9fa5]{1}/g;
            // const notReg = /[\w|\s|.|·]{1}/g;
            // const pattern = /[1234567890]/;
            // const cn = value.match(reg) || [];
            // const en = value.match(notReg) || [];
            // const number = value.match(pattern);
            // this.textError = cn.length + en.length === value.length && !number;
            // this.errorMsg = this.textError ? '' : '請勿包含特殊字元';
            // return this.textError;
            this.textError = false;
            if (this.inputText !== '') {
                this.errorMsg = '';
                this.textError = true;
            }
            // this.textError = this.errorMsg === '';
            return this.textError;
        },
        setActionInputs() {
            this.$store.dispatch('setSearchInputs',
                { input: this.inputText, orderby: null, type: null, page: 1 });
        },
        goToSearchPage() {
            this.errorMsg = this.inputText === '' ? '請輸入搜尋內容' : '';
            if (this.inputText.trim() !== '' && this.inputValid(this.inputText)) {
                this.setActionInputs();
                this.$router.push({ name: 'search', params: { page: 1, search: this.inputText } }).catch(() => { });
                this.inputText = '';
                this.closeSearchBlock();
            }
        }
    },
};
</script>
<style lang="scss" scoped>
$normal: 1rem;
$small: 0.75rem;

.logo {
    @include media-breakpoint-up(sm) {
        width: calc(100% - 4rem);
    }
    img {
        width: 110px;
        height: auto;
        @include media-breakpoint-up(sm) {
            width: 125px;
        }
    }
}
.underline {
    border-bottom: 1px solid $gray-300;
}
.headerbar {
    z-index: 15;
    height: 58px;
    padding-top: 0.6rem;
    width: 100%;
    box-shadow: 0px 1px 0px #ccc;
    &:before {
        position: fixed;
        top: 0;
        left: 0;
        content: '';
        width: 100%;
        height: 5px;
        background: linear-gradient(to right, #0098d1 5%, #01b6b2 95%);
    }
    .logoImg {
        width: 110px;
        @include media-breakpoint-up(md) {
            width: 127px;
        }
    }
    .sublogo {
        position: relative;
        vertical-align: bottom;
        margin-left: 1.1rem;
        margin-bottom: -5px;
        font-size: 1rem;
        display: inline-block;
        color: #000;
        background-color: #fff;
        @include media-breakpoint-up(md) {
            // margin-left: 1.125rem;
            font-size: 1.125rem;
        }
        &:before {
            position: absolute;
            content: '';
            width: 2px;
            height: 1rem;
            bottom: 4px;
            left: 0;
            background-color: $gray-300;
            margin-top: 0.15rem;
            margin-left: -0.55rem;
            @include media-breakpoint-up(sm) {
                margin-top: 0.5rem;
            }
        }
    }
}
.cover {
    width: 100%;
    height: 100vh;
    background-color: $gray-800;
    opacity: 0.7;
    z-index: 19;
    position: fixed;
    top: 0;
    left: 0;
    animation: fadeIn 0.3s 0.1s linear alternate both;
    @include media-breakpoint-up(md) {
        z-index: 4;
    }
}
.searchBlock {
    width: 95%;
    max-width: 360px;
    height: 100vh;
    z-index: 20;
    left: 0;
    position: fixed;
    top: 0;
    background-color: $white;
    box-shadow: 1px -1px 1px $gray-300;
    @include media-breakpoint-up(md) {
        width: 100%;
        max-width: 100%;
        height: auto;
        z-index: 10;
        top: 58px;
    }
    .errorMsg {
        height: 1rem;
        font-size: 0.75rem;
        color: rgb(250, 61, 61);
        @include media-breakpoint-up(md) {
            height: 1.25rem;
            font-size: 0.875rem;
        }
    }
    .searchBlock__content {
        width: 100%;
        overflow-y: auto;
        height: calc(100vh - 49px);
        @include media-breakpoint-up(md) {
            height: auto;
        }
    }
    .search__input {
        width: calc(100% - 5.55rem);
        max-width: 450px;
        display: inline-block;
        height: 50px;
        /* line-height: 1; */
        padding-left: 1rem;
        margin-right: 0.25rem;
        border-color: $primary;
        @include media-breakpoint-up(md) {
            width: calc(100% - 6.25rem);
            margin-right: 0.5rem;
        }
        @include media-breakpoint-up(lg) {
            width: calc(100% - 18% - 0.5rem);
        }
        @include media-breakpoint-up(xl) {
            width: calc(100% - 8rem);
        }
    }
    .search__btn {
        width: 5.25rem;
        height: 50px;
        letter-spacing: 3px;
        vertical-align: top;
        @include media-breakpoint-up(md) {
            width: 5.75rem;
        }
        @include media-breakpoint-up(lg) {
            width: 18%;
        }
        @include media-breakpoint-up(xl) {
            width: 7.5rem;
        }
    }
}
.movedown-enter-active {
    animation: movedown 0.5s;
}

.movedown-leave-active {
    animation: movedown 0.5s;
    animation-direction: reverse;
}
@keyframes movedown {
    0% {
        top: -300px;
    }
    100% {
        top: 58px;
    }
}
.move-enter-active {
    animation: go-move 0.35s;
}

.move-leave-active {
    animation: go-move 0.35s;
    animation-direction: reverse;
}
@keyframes go-move {
    0% {
        left: -1200px;
    }
    100% {
        left: 0;
    }
}

.article {
    .contentTitle {
        font-size: 1.25rem;
        @extend %ellipsis-single;
        line-height: 1;
        span {
            font-size: 0.875rem;
            @extend %ellipsis-single;
        }
    }
    .content {
        font-size: 0.875rem;
        @extend %ellipsis-single;
        position: relative;
        height: 35px;
        line-height: 1.25;
        &:after {
            content: '\02026';
            display: block;
            position: absolute;
            right: 0;
            bottom: 0;
            color: #333;
            background-color: #fff;
            padding: 0 0.2rem;
        }
    }

    height: 7rem;
    overflow: hidden;
    .photo {
        background-position: center center;
        background-size: cover;
        border: 0;
        background-repeat: no-repeat;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 0.7;
    }
}
</style>
